import {SectionCover} from './SectionCover';
import coverImage from '../../../../assets/pdf/sections/four.png';

export const SectionCoverFour = () => {
  return <SectionCover sectionTitle={'sectionPages.four'} coverImage={coverImage} />;
};
